
<div class="page-header">
  <div>
    <h1>Passwort vergessen</h1>
    <p>Fordere einen Link zum Zurücksetzen deines Passworts an.</p>
  </div>
</div>

<section class="panel">
  <form class="form" [formGroup]="form" (ngSubmit)="submit()">
    <label>
      E-Mail
      <input type="email" formControlName="email" autocomplete="username">
    </label>

    @if (submitted() && form.controls.email.invalid) {
      <p class="field-error">Bitte eine gültige E-Mail eingeben.</p>
    }

    @if (message()) {
      <p class="info-message">{{ message() }}</p>
    }

    @if (resetUrl()) {
      <a class="table-link" [href]="resetUrl()">Reset-Link öffnen</a>
    }

    <button class="primary-button" type="submit" [disabled]="loading()">
      {{ loading() ? 'Wird gesendet...' : 'Passwort-Link anfordern' }}
    </button>

    <a class="table-link" routerLink="/login">Zurück zur Anmeldung</a>
  </form>
</section>
  
